<template>
    <div class="view-login bg-light">
        <div class="container card shadow-sm p-4">
            <b-row no-gutters align-v="center" class="mb-0 mb-md-2">
                <b-col>
                    <h4 class="text-center">Bem-vindo ao SIMBAR!</h4>
                </b-col>
            </b-row>
            <b-row cols="1" cols-md="2">
                <b-col class="logos-container">
                    <div class="text-center text-muted">
                        Projeto desenvolvido em colaboração
                    </div>
                    <logo-carousel />
                </b-col>
                <b-col align-self="center">
                    <b-form @submit.prevent="onSubmit">
                        <b-form-group
                            :invalid-feedback="username.invalidFeedback"
                            :state="username.state"
                        >
                            <b-input-group>
                                <template v-slot:append>
                                    <b-input-group-text>
                                        <i class="fas fa-user fa-fw" />
                                    </b-input-group-text>
                                </template>
                                <b-form-input
                                    ref="username"
                                    v-model="username.value"
                                    name="username"
                                    placeholder="Nome de usuário"
                                    :state="username.state"
                                    :disabled="authenticating"
                                    trim
                                    @change="username.state = null"
                                />
                            </b-input-group>
                        </b-form-group>
                        <b-form-group
                            :invalid-feedback="password.invalidFeedback"
                            :state="password.state"
                        >
                            <b-input-group>
                                <template v-slot:append>
                                    <b-input-group-text>
                                        <i class="fas fa-lock fa-fw" />
                                    </b-input-group-text>
                                </template>
                                <b-form-input
                                    v-model="password.value"
                                    name="password"
                                    type="password"
                                    placeholder="senha"
                                    :state="password.state"
                                    :disabled="authenticating"
                                    trim
                                    @change="password.state = null"
                                />
                            </b-input-group>
                        </b-form-group>
                        <b-form-checkbox
                            id="id_remember_me"
                            v-model="rememberMe"
                            :value="true"
                            :unchecked-value="false"
                            class="mb-3"
                            :disabled="authenticating"
                        >
                            Lembrar-me
                        </b-form-checkbox>
                        <b-alert
                            :show="!!nonFieldErrorMessage"
                            variant="danger"
                        >
                            {{ nonFieldErrorMessage }}
                        </b-alert>
                        <b-button
                            type="submit"
                            variant="primary"
                            block
                            :disabled="authenticating"
                            class="d-flex justify-content-center align-items-center"
                        >
                            <template v-if="authenticating">
                                <b-spinner small type="grow" class="mr-1" />
                                <span>Aguarde...</span>
                            </template>
                            <span v-else>Entrar</span>
                        </b-button>
                    </b-form>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import LogoCarousel from "./components/LogoCarousel";
export default {
    name: "Login",
    components: {
        LogoCarousel
    },
    data() {
        return {
            username: {
                state: null,
                value: "",
                invalidFeedback: ""
            },
            password: {
                state: null,
                value: "",
                invalidFeedback: ""
            },
            rememberMe: false,
            nonFieldErrorMessage: ""
        };
    },
    computed: {
        authenticating() {
            return this.$store.state.auth.authenticating;
        }
    },
    mounted() {
        this.focusUsername();
    },
    methods: {
        focusUsername() {
            this.$refs.username.$el.focus();
        },
        async onSubmit() {
            this.nonFieldErrorMessage = "";
            this.username.state = null;
            this.username.invalidFeedback = "";
            this.password.state = null;
            this.password.invalidFeedback = "";

            const data = {
                username: this.username.value,
                password: this.password.value,
                rememberMe: this.rememberMe
            };

            try {
                const location = {};
                if (this.$route.query.next) {
                    location.path = this.$route.query.next;
                } else {
                    location.name = "home";
                }
                await this.$store.dispatch("auth/login", data);
                this.$router.push(location, () => {});
            } catch ({ response }) {
                if (response.status === 400) {
                    const { data } = response;
                    if ("username" in data) {
                        this.username.state = false;
                        this.username.invalidFeedback = data.username[0];
                    }

                    if ("password" in data) {
                        this.password.state = false;
                        this.password.invalidFeedback = data.password[0];
                    }

                    if ("non_field_errors" in data) {
                        this.nonFieldErrorMessage = data.non_field_errors[0];
                        this.password.value = "";
                    }
                    this.focusUsername();
                } else {
                    this.nonFieldErrorMessage =
                        "Erro desconhecido, tente novamente mais tarde.";
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.view-login {
    display: flex;
    align-items: center;
    min-height: 100%;

    .logos-container {
        border-bottom: $border-width solid $border-color;
        margin-bottom: 1rem;
    }
}

@include media-breakpoint-up(md) {
    .view-login {
        .container {
            width: 650px;
        }
        .logos-container {
            border-bottom: none;
            border-right: $border-width solid $border-color;
        }
    }
}
</style>
